/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespComponents_viewer = {
    readonly isBillboardAdEnabled: boolean | null;
    readonly isThinItemSearchEnabled: boolean | null;
    readonly isMoreWaysToBrowseEnabled: boolean | null;
    readonly isFollowSearchEnabled: boolean | null;
    readonly isContentModuleEnabled: boolean | null;
    readonly isWordpressArticlesEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespNullSearchResults_viewer" | "SbRespFollowSearchBanner_viewer" | "SbRespPriceTiles_viewer" | "SbRespTradeOnApprovalPromoBanner_viewer" | "SbRespMainContent_viewer" | "SuspectedTradeUserLoader_viewer" | "SbSharedTopTileController_viewer">;
    readonly " $refType": "SbRespComponents_viewer";
};
export type SbRespComponents_viewer$data = SbRespComponents_viewer;
export type SbRespComponents_viewer$key = {
    readonly " $data"?: SbRespComponents_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespComponents_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "featureName",
    "value": "NON_MVP_SEARCH_BROWSE"
  }
];
return {
  "kind": "Fragment",
  "name": "SbRespComponents_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isBillboardAdEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isThinItemSearchEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isMoreWaysToBrowseEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isFollowSearchEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isContentModuleEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "BROWSE_CONTENT_MODULES"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"BROWSE_CONTENT_MODULES\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isWordpressArticlesEnabled",
      "name": "featureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "wordpressArticles"
        }
      ],
      "storageKey": "featureFlag(feature:\"wordpressArticles\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SbRespPriceTiles_viewer",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbRespTradeOnApprovalPromoBanner_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespMainContent_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SuspectedTradeUserLoader_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedTopTileController_viewer",
      "args": null
    }
  ]
};
})();
(node as any).hash = '60968940bc033b5579d465dc7859a313';
export default node;
